import { STORY_CLOSER, STORY_META, STORY_PARAGRAPHS, STORY_QUOTE } from "../data/content";

export function Story() {
  return (
    <section id="story" className="section">
      <div className="container container--1080">
        <div className="section-head">
          <p className="eyebrow">Our Story</p>
          <h2 className="h2">How we got here</h2>
        </div>

        <div className="grid grid--gap40 auto-280 story__grid">
          {/* TODO: replace with the 900×1200 portrait. */}
          <div className="placeholder story__portrait" data-par="0.14">
            <span className="mono-caption">Portrait — Aimee &amp; Ben (900×1200)</span>
          </div>

          <div className="story__text">
            {STORY_PARAGRAPHS.map((text) => (
              <p className="body" key={text.slice(0, 24)}>
                {text}
              </p>
            ))}
            <p className="quote">{STORY_QUOTE}</p>
            <p className="body">{STORY_CLOSER}</p>

            <div className="story__meta">
              {STORY_META.map((item) => (
                <div key={item.label}>
                  <p className="eyebrow eyebrow--muted">{item.label}</p>
                  <p className="body">{item.value}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
